var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLegislatie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 91 93",
    style: {
      enableBackground: "new 0 0 91 93"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#DADBE2;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#32324E;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91,0H20.06L1.67,19.59v0.15c-0.97,0.87-1.59,2.13-1.59,3.54v64.89c0,2.63,2.13,4.76,4.76,4.76h51.98 c1.64,0,3.09-0.83,3.95-2.1L91,62.95V0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,91.93c-2.75,0-5-2.24-5-5V23.97c0-2.75,2.24-4.99,5-4.99h49.95c2.75,0,5,2.24,5,4.99v62.97 c0,2.75-2.24,5-5,5H6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.95,19.97c2.2,0,3.99,1.79,3.99,3.99v62.97c0,2.2-1.79,3.99-3.99,3.99H6c-2.2,0-4-1.79-4-3.99V23.97 c0-2.2,1.79-3.99,4-3.99H55.95 M55.95,17.97H6c-3.31,0-6,2.68-6,5.99v62.97c0,3.31,2.68,5.99,6,5.99h49.95 c3.31,0,5.99-2.68,5.99-5.99V23.97C61.94,20.65,59.26,17.97,55.95,17.97L55.95,17.97z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.95,16.99H12.99V29h35.96V16.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.97,7c-5.24,0-9.49,4.26-9.49,9.51c0,5.25,4.25,9.51,9.49,9.51c5.24,0,9.49-4.26,9.49-9.51 C40.46,11.26,36.21,7,30.97,7z M30.96,21.01c-2.49,0-4.5-2.02-4.5-4.51c0-2.49,2.02-4.51,4.5-4.51c2.49,0,4.5,2.02,4.5,4.51 C35.46,18.99,33.44,21.01,30.96,21.01z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.04,58.61v1.99h-3.99v-1.99H33.04 M37.04,54.61H25.05v7.99c0,1.1,0.9,2,2,2h7.99c1.1,0,2-0.89,2-2V54.61 L37.04,54.61z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.07,58.61v-18c0-1.1,0.9-2,2-2c1.1,0,2,0.89,2,2v18c0,1.1-0.89,2-2,2C19.96,60.61,19.07,59.72,19.07,58.61 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.05,58.61v-18c0-1.1,0.89-2,2-2c1.1,0,2,0.89,2,2v18c0,1.1-0.9,2-2,2C39.94,60.61,39.05,59.72,39.05,58.61 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.05,82.59V64.6h4v17.98H29.05z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.03,44.62v9.98H17.06v-9.98H45.03 M47.03,40.62H15.06c-1.1,0-2,0.9-2,2v13.99c0,1.1,0.89,2,2,2h31.97 c1.1,0,2-0.89,2-2V42.62C49.03,41.52,48.13,40.62,47.03,40.62L47.03,40.62z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M31.04,76.59c2.21,0,4,1.79,4,4c0,2.21-1.79,4-4,4s-4-1.79-4-4C27.05,78.38,28.84,76.59,31.04,76.59z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegislatie);
export default __webpack_public_path__ + "static/media/icon_legislatie.e430e595ed004e36ea6633b77806974d.svg";
export { ForwardRef as ReactComponent };